import { render } from "./GetToKnowMe.vue?vue&type=template&id=525164b2&scoped=true"
import script from "./GetToKnowMe.vue?vue&type=script&lang=js"
export * from "./GetToKnowMe.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src286570729/src/astaykov-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-525164b2"]])

export default __exports__